/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_CollapseInputs */

const en_directory_sidebar_collapse = /** @type {(inputs: Directory_Sidebar_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse`)
};

const zh_directory_sidebar_collapse = /** @type {(inputs: Directory_Sidebar_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收起`)
};

/**
* | output |
* | --- |
* | "Collapse" |
*
* @param {Directory_Sidebar_CollapseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_collapse = /** @type {((inputs?: Directory_Sidebar_CollapseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_CollapseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_collapse(inputs)
	return zh_directory_sidebar_collapse(inputs)
});
export { directory_sidebar_collapse as "directory.sidebar.collapse" }